// useStore.js
"use client"; // Ensure this is a client-side component

import useAuthStore from "./useAuthStore";
import useBoxOrderStore from "./useBoxOrderStore";
import useCartStore from "./useCartStore";
import useCountryStore from "./useCountryStore";
import useHomePopupStore from "./useHomePopupStore"; // Import the home popup store
import usePaymentStore from "./usePaymentStore"; // Import the payment store
import useShopStore from "./useShopStore";
import useSurveyStore from "./useSurveyStore";
import useUserStore from "./useUserStore";
import useShopOrderStore from "./useShopOrderStore";
import useProductLayoutStore from "./useProductLayoutStore";

const useStore = () => {
    //  Auth Store
    const { authSession, authStatus, setAuthSession } = useAuthStore();

    //  Survey Store

    const {
        surveyAnswers,
        surveyQuestions,
        setSurveyAnswers,
        setSurveyQuestion,
        userSurvey,
        getUserSurvey,
        createUserSurvey,
        surveyLoading,
        setSurveyType,
        surveyInfo,
        resetSurvey,
        setSurveyInfo,
        hasSurveyHydrated,
        fieldsValidated,
        setFieldsValidated,
    } = useSurveyStore();

    //  Cart Store
    const {
        cartId,
        cartData,
        updateCartData,
        clearCartData,
        clearCart,
        setCartId,
        cartLoading,
        checkoutDetails,
        setCheckoutDetails,
        hasCartHydrated,
        createCheckout,
        checkoutLoading,
        getCheckoutDetails,
        updateShipping,
    } = useCartStore();

    //  User Store
    const {
        userData,
        accessToken,
        nextStep,
        previousStep,
        loading,
        boxItems,
        returnStep,
        error,
        forgotPasswordSuccess,
        wantDiscount,
        personality,
        resetUser,
        resetState,
        changeDiscountFlag,
        setPersonality,
        addItem,
        setEmailVerified,
        changeStep,
        changeInstructionsPage,
        resetBoxItems,
        getCustomerData,
        updateUserData,
        updateCustomer,
        updateCustomerData,
        updatePassword,
        keepAllBox,
        returnOrder,
        forgotPassword,
        hasUserHydrated,
        setLoading,
    } = useUserStore();

    //  Box Order Store
    const {
        userBoxes,
        boxLoading,
        box,
        step,
        boxOrderError,
        goBack,
        changeOrderStep,
        resetBox,
        updateBox,
        getUserBoxes,
        orderABoxStepOne,
        orderABoxStepTwo,
    } = useBoxOrderStore();

    const { shopOrders, loadingShopOrders, getUserShopOrders } =
        useShopOrderStore();

    //  Country Store
    const {
        country,
        flag,
        currency,
        price,
        exchangeRate,
        anonymusId,
        triggeredGeoIP2,
        hasCountryHydrated,
        showCountrySelectionPopUp,
        changeCurrency,
        setAnonymusId,
        countriesRates,
        countryDefaultValue,
        getCountriesList,
        resetCountryStore,
    } = useCountryStore();

    //  Home Popup Store
    const { display, loaded, setVisibility, setLoad } = useHomePopupStore();

    // Ecom Shop Store
    const { shopBrands, hasShopHydrated, getShopBrands } = useShopStore();

    //  Payment Store
    const {
        userTransactions,
        transactionLoading,
        paymentError,
        paymentLoading,
        transactionId,
        saveCard,
        hasConfirmedSurvey,
        resetPayment,
        paymentCard,
        verifyCard,
        getUserTransactions,
        PaymentConfirmation,
        deleteCard,
    } = usePaymentStore();

    // ProductLayout Store

    const { setLayout, layout } = useProductLayoutStore();

    return {
        // --- Prouduct Layout ---
        setLayout,
        layout,

        // --- Auth Store ---
        authSession,
        authStatus,
        setAuthSession,

        // --- Survey Store ---
        surveyAnswers,
        surveyQuestions,
        setSurveyAnswers,
        setSurveyQuestion,
        userSurvey,
        getUserSurvey,
        createUserSurvey,
        setSurveyType,
        surveyLoading,
        surveyInfo,
        resetSurvey,
        setSurveyInfo,
        hasSurveyHydrated,
        countryDefaultValue,
        resetCountryStore,
        fieldsValidated,
        setFieldsValidated,

        // --- Cart Store ---
        cartId,
        cartData,
        updateCartData,
        clearCartData,
        clearCart,
        setCartId,
        cartLoading,
        checkoutDetails,
        setCheckoutDetails,
        hasCartHydrated,
        createCheckout,
        checkoutLoading,
        getCheckoutDetails,
        updateShipping,

        // --- User Store ---
        userData,
        accessToken,
        nextStep,
        previousStep,
        loading,
        boxItems,
        returnStep,
        error,
        forgotPasswordSuccess,
        wantDiscount,
        personality,
        resetUser,
        resetState,
        changeDiscountFlag,
        setPersonality,
        addItem,
        setEmailVerified,
        changeStep,
        changeInstructionsPage,
        resetBoxItems,
        getCustomerData,
        updateUserData,
        updateCustomer,
        updateCustomerData,
        updatePassword,
        keepAllBox,
        returnOrder,
        hasUserHydrated,
        forgotPassword,
        setLoading,

        // --- Box Order Store ---
        userBoxes,
        boxLoading,
        box,
        step,
        boxOrderError,
        goBack,
        changeOrderStep,
        resetBox,
        updateBox,
        getUserBoxes,
        orderABoxStepOne,
        orderABoxStepTwo,

        // --- Country Store ---
        country,
        flag,
        currency,
        price,
        exchangeRate,
        anonymusId,
        triggeredGeoIP2,
        hasCountryHydrated,
        showCountrySelectionPopUp,
        changeCurrency,
        setAnonymusId,
        countriesRates,
        getCountriesList,
        resetCountryStore,

        // --- Home Popup Store ---
        display,
        loaded,
        setVisibility,
        setLoad,

        // --- Ecom Shop Store ---
        shopBrands,
        getShopBrands,
        hasShopHydrated,

        // --- Payment Store ---
        userTransactions,
        transactionLoading,
        paymentError,
        paymentLoading,
        transactionId,
        saveCard,
        hasConfirmedSurvey,
        resetPayment,
        paymentCard,
        verifyCard,
        getUserTransactions,
        PaymentConfirmation,
        deleteCard,

        // --- Shop Order Store ---

        shopOrders,
        loadingShopOrders,
        getUserShopOrders,
    };
};

export default useStore;
